import cx from 'classnames';
import { format, isSameDay } from 'date-fns';
import { LessonCalendar } from 'education-icons';
import React from 'react';

import { TEXT_MARKUP_TYPE } from '../../constants';
import Text from '../../text/text';

import './lesson-meta__date.scss';

interface Props {
    startDate: Date | null;
    endDate: Date | null;
    mix?: string;
    textId?: string;
    showIcon?: boolean;
}

enum PERIOD_TYPE {
    OPEN_START = 'openStart',
    OPEN_END = 'openEnd',
    SAME_DAY = 'sameDay',
    DEFAULT = 'default',
}

export const Date = ({ startDate, endDate, mix, textId, showIcon }: Props) => {
    if (!startDate && !endDate) {
        return null;
    }

    let type = PERIOD_TYPE.DEFAULT;

    if (startDate) {
        if (!endDate) {
            type = PERIOD_TYPE.OPEN_END;
        } else if (isSameDay(startDate, endDate)) {
            type = PERIOD_TYPE.SAME_DAY;
        }
    } else {
        type = PERIOD_TYPE.OPEN_START;
    }

    return (
        <span className={cx('lesson-meta__date', mix)}>
            {showIcon && <LessonCalendar className="lesson-meta__date-icon" />}
            <Text
                id={textId || 'lesson-meta.period'}
                type={TEXT_MARKUP_TYPE.MARKDOWN}
                values={{
                    type,
                    startDate: startDate ? format(startDate, 'dd.MM') : '',
                    endDate: endDate ? format(endDate, 'dd.MM') : '',
                }}
            />
        </span>
    );
};

export default Date;
